import { render, staticRenderFns } from "./receivable.vue?vue&type=template&id=45056731&"
import script from "./receivable.vue?vue&type=script&lang=js&"
export * from "./receivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports